/** Format an integer millisecond delta without losing its sign. */
export function formatSignedGapMs(deltaMs: number): string {
  if (!Number.isFinite(deltaMs) || deltaMs === 0) return '0.000';
  return `${deltaMs > 0 ? '+' : '-'}${(Math.abs(deltaMs) / 1000).toFixed(3)}`;
}

export type GlobalGapTone = 'purple' | 'red' | 'neutral';

/** Global-best comparison for a cumulative sector or completed-lap split. */
export function classifyGlobalGap(deltaMs: number): GlobalGapTone {
  if (!Number.isFinite(deltaMs) || deltaMs === 0) return 'neutral';
  return deltaMs < 0 ? 'purple' : 'red';
}

export function describeGlobalGap(deltaMs: number, sectorNumber: number): string {
  if (deltaMs === 0) return `Sector ${sectorNumber}, equal to the global best.`;
  return `Sector ${sectorNumber}, ${(Math.abs(deltaMs) / 1000).toFixed(3)} seconds ${
    deltaMs < 0 ? 'faster than' : 'slower than'
  } the global best.`;
}
